<div class="header-navigation-wrapper">
  <div id="user-wrapper">
    <msd-avatar id="avatar" [src]="(accountStatus$|async)?.dietitian?.picture?.url" [text]="(accountStatus$|async)?.dietitian?.initials"></msd-avatar>
    <h2 id="username">{{(accountStatus$|async)?.dietitian?.fullName ?? 'Anonyme'}}</h2>
    <span *ngIf="(accountStatus$|async)?.dietitian?.subscription?.isActive" class="badge badge-gradient badge-premium">PRO</span>
  </div>

  <msd-segmented-navigation #tabs [items]="segmentedItems"></msd-segmented-navigation>
</div>
<hr />

<div id="content-wrapper" >
  <router-outlet></router-outlet>
</div>
